var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99844 12.3518C8.22344 12.3518 6.77344 10.9102 6.77344 9.12682C6.77344 7.34349 8.22344 5.91016 9.99844 5.91016C11.7734 5.91016 13.2234 7.35182 13.2234 9.13516C13.2234 10.9185 11.7734 12.3518 9.99844 12.3518ZM9.99844 7.16016C8.9151 7.16016 8.02344 8.04349 8.02344 9.13516C8.02344 10.2268 8.90677 11.1102 9.99844 11.1102C11.0901 11.1102 11.9734 10.2268 11.9734 9.13516C11.9734 8.04349 11.0818 7.16016 9.99844 7.16016Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0014 19.51C8.76803 19.51 7.52637 19.0433 6.5597 18.1183C4.10137 15.7516 1.3847 11.9766 2.4097 7.48496C3.3347 3.40996 6.89303 1.58496 10.0014 1.58496C10.0014 1.58496 10.0014 1.58496 10.0097 1.58496C13.118 1.58496 16.6764 3.40996 17.6014 7.49329C18.618 11.985 15.9014 15.7516 13.443 18.1183C12.4764 19.0433 11.2347 19.51 10.0014 19.51ZM10.0014 2.83496C7.57637 2.83496 4.4597 4.12663 3.6347 7.75996C2.7347 11.685 5.20137 15.0683 7.4347 17.21C8.87637 18.6016 11.1347 18.6016 12.5764 17.21C14.8014 15.0683 17.268 11.685 16.3847 7.75996C15.5514 4.12663 12.4264 2.83496 10.0014 2.83496Z",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.40c3d5c25821db150567860607b58e12.svg";
export { ForwardRef as ReactComponent };